(function columnResizePlugin(global) {
  "use strict";

  /**
  * Плагин для изменения ширины колонок таблицы.
  *
  * @class WebAccess.components.dataViews.gridPlugins.ColumnResizePlugin
  * @extends WebAccess.Plugin
  * @property {string} name Имя плагина
  * @since 5.2.0.1100
  */
  global.ColumnResizePlugin = WA.Plugin.extend({
    name: 'ColumnResizePlugin',

    // Грид. 
    _grid: null,
    // Настройки.
    _settings: null,

    init: function (settings) {
      this._super();
      this._settings = $.extend({}, settings);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Регистрирует плагин.
    *
    * @method WebAccess.components.dataViews.gridPlugins.ColumnResizePlugin#register
    * @param {WebAccess.components.dataViews.Grid} Таблица
    * @since 5.2.0.1100
    * @return {object} Ассоциативный массив, содержащий публичные методы.
    */
    register: function (grid) {
      var me = this;
      me._grid = grid;

      me._grid.bind(WA.CMP.DV.Grid.EVENT.COLUMN_INIT, $.proxy(me._onColumnInit, me));
      //me._grid.bind(WA.CMP.DV.Grid.EVENT.BEFORE_GRID_INIT, $.proxy(me._onGridBeforeInit, me));
      me._grid.bind(WA.CMP.DV.Grid.EVENT.GRID_INIT, $.proxy(me._onGridInit, me));
      me._grid.bind(WA.CMP.DV.Grid.EVENT.AFTER_DATA_LOADED, $.proxy(me._onAfterGridDataLoaded, me));

      // Отключать надо для планшетов и если будут редактироваться ячейки.
      if (!me._settings['disableOnResizeBinding']) {
        $(window).on("resizeEnd", $.proxy(me._onWindowsResize, me));
      }

      return {
        'autoAdjustColumnWidth': $.proxy(me._autoAdjustColumnWidth_exported, me)
      };
    },

    /**
    * Делаем все колонки растягивабельными
    * @method WebAccess.components.dataViews.gridPlugins.CheckboxPlugin#_onColumnInit
    * @param {object} byref_column колонка
    * @private
    * @since 5.2.0.1100
    */
    _onColumnInit: function (byref_column) {
      var me = this;
      var isSpecialColumn = (byref_column.id.charAt(0) === '_');
      byref_column.resizable = !isSpecialColumn;

      if (me._grid.state && me._grid.state['ColumnsWidth'] && me._grid.state['ColumnsWidth'][byref_column.id] > 0) {
        byref_column.width = me._grid.state['ColumnsWidth'][byref_column.id];
      }
    },

    /**
     * Хэндлер события инициализации грида.
     * @method WebAccess.components.dataViews.gridPlugins.ColumnResizePlugin#_onGridInit
     * @private
     * @since 5.2.0.1100
     */
    _onGridInit: function () {
      var me = this;

      // Если ColumnsWidth пустой или заполнен некорректными значениями заполнить его при инициализации грида,
      // это нужно для корректной выгрузки записей справочника в ексель.
      if (me._columnsWidthIsEmpty())
        me._saveColumnWidthState(me._grid.state.IsColumnsAutoWidthEnabled);

      me._grid.grid.onColumnsResized.subscribe(function () {
        me._saveColumnWidthState(me._grid.state.IsColumnsAutoWidthEnabled);
      });
    },

    /**
     * Возвращает признак пустоты объекта Core.grid.reference.state.ColumnsWidth
     * @returns {bool}
     * @private
     * @since 5.2.0.2005-beta
     */
    _columnsWidthIsEmpty: function () {
      var result = false;
      var columnsWidth = this._grid.state['ColumnsWidth'];

      if (jQuery.isEmptyObject(columnsWidth)) {
        result = true;
      } else {
        $.each(columnsWidth, function (key, value) {
          // При первом открытии справочника объект пустой, а при обновлении размеры всех колонок -1.
          if (value === -1) {
            result = true;
            return false;
          }
        });
      }

      return result;
    },

    /**
     * Хэндлер события "После загрузки данных".
     * @method WebAccess.components.dataViews.gridPlugins.ColumnResizePlugin#_onAfterGridDataLoaded
     * @private
     * @since 5.2.0.1100
     */
    _onAfterGridDataLoaded: function () {
      if (this._grid.state.IsColumnsAutoWidthEnabled === true) {
        this._autoAdjustColumnWidth_exported(true);
      }
    },

    /**
     * Хэндлер события "Изменение размера окна браузера".
     * @method WebAccess.components.dataViews.gridPlugins.ColumnResizePlugin#_onWindowsResize
     * @private
     * @since 5.2.0.1100
     */
    _onWindowsResize: function () {
      this._grid.grid.resizeCanvas();
      this._onAfterGridDataLoaded.call(this);
    },

    /**
    * Автоподбор ширины колонок.
    * @method WebAccess.components.dataViews.gridPlugins.ColumnResizePlugin#_autoAdjustColumnWidth_exported
    * @param {boolean} isEnabled Включен ли автоподбор ширины колонок.
    * @private
    * @since 5.2.0.1100
    */
    _autoAdjustColumnWidth_exported: function (isEnabled) {
      var me = this;

      // Что бы нельзя было при включенном режиме растянуть колонки за пределы видимой области.
      me._grid.grid.setOptions({
        forceFitColumns: isEnabled
      });

      if (isEnabled) {
        //Если включили, то отресайзим колонки.       
        me._grid.grid.autosizeColumns();
      }

      me._saveColumnWidthState(isEnabled);
    },

    /**
    * Сохранение текущих размеров колонок в состоянии грида.
    * @method WebAccess.components.dataViews.gridPlugins.ColumnResizePlugin#_saveColumnWidthState
    * @param {boolean} IsColumnsAutoWidthEnabled Включен ли автоподбор ширины колонок
    * @private
    * @since 5.2.0.1100
    */
    _saveColumnWidthState: function (IsColumnsAutoWidthEnabled) {
      var me = this;
      var columnsWidth = {};
      var columns = me._grid.grid.getColumns();
      for (var i = 0; i < columns.length; i++) {
        // "~~" операция двойного побитового NOT.
        // Использется как более быстрая реализация Math.floor().
        // floor() используется для округления числа в меньшую сторону.
        columnsWidth[columns[i].id] = ~~columns[i].width;
      }

      // Обновим состояние (сохраним в профиль пользователя).
      me._grid.updateState({
        IsColumnsAutoWidthEnabled: IsColumnsAutoWidthEnabled,
        ColumnsWidth: columnsWidth
      }, true);
    }
  });

})(WA.components.dataViews.gridPlugins);